import React from 'react';
import './DataShowcase.css';

const DataShowcase = () => {
  const data = [
    { number: '15年', label: '深耕造价咨询', desc: '专注工程造价领域' },
    { number: '1200+', label: '项目实战经验', desc: '累计审核金额超500亿' },
    { number: '38名', label: '注册造价工程师', desc: '12名高级工程师' },
    { number: '98.6%', label: 'AI审核准确率', desc: '效率提升85%' },
    { number: '92%', label: '客户续约率', desc: '服务满意度持续领先' }
  ];

  return (
    <section className="data-showcase">
      <div className="container">
        <div className="data-grid">
          {data.map((item, index) => (
            <div key={index} className="data-item">
              <div className="data-number">{item.number}</div>
              <div className="data-label">{item.label}</div>
              <div className="data-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DataShowcase;

